import Vue from 'vue'
import Vuex from 'vuex'
import vuexAlong from 'vuex-along'
import Mp3Voice from '../../static/audioVoice.mp3'

Vue.use(Vuex);
/**
 * Vuex全局状态管理
 * @param options {Array} 用于渲染tabs的数组
 */
//Vuex配置
const store = new Vuex.Store({
  state: {
    //  服务器http://192.168.0.16:9528/oa_manage   本地 http://192.168.0.22:8004
    local: 'http://192.168.0.16:9528/oa_manage',
    userInfo: {}, //登陆后店家信息
    options: [],
    activeIndex: '',
    curMem:{},
    aliveStatus:false,
    alivePage:1,//操作完成保留页码状态
    vcode:false,//发送验证码验证
    shoppingNum: 0,//购物车数量
    shoppingSearch: '',//商城查询 ''全部，CP产品，YQ仪器，WL物料，TC套餐，JCPZ配置
    resourceList:[],//权限列表
    provincialCity:'',//省市区
    royaltyData:'',//提成数据
    roleFlags:'',//判断登录是否老板
  },
  mutations: {
    //更新用户信息
    updateUserInfo(state, newUserInfo) {
      state.userInfo = newUserInfo;
    },
    // 添加tabs
    add_tabs (state, data) {
      state.options.push(data);
    },
    // 删除tabs
    delete_tabs (state, route) {
      let index = 0;
      for (let option of state.options) {
        if (option.route === route) {
          break;
        }
        index++;
      }
      state.options.splice(index, 1);
    },
    // 设置当前激活的tab
    set_active_index (state, index) {
      state.activeIndex = index;
    },
    // 设置保留状态
    setAliveStatus (state, newVal) {
      state.aliveStatus = newVal;
    },
    // 设置页码保留状态
    setAlivePage (state, newVal) {
      state.alivePage = newVal;
    },
    // 设置发送验证码状态
    setVcode (state, newVal) {
      state.vcode = newVal;
    },
    //购物车数量更新
    UPDATE_SHOPPING_CAR(state,newVal){
      state.shoppingNum = newVal;
    },
    //商城查询
    SEARCH_SHOPPING_GOODS(state,newVal){
      state.shoppingSearch = newVal;
    },
    // 登陆后权限列表更新
    setResourceList (state, newVal) {
      state.resourceList = newVal;
    },
    setProvincialCity(state, newVal){
      state.provincialCity = newVal;
    },
    setRoyaltyData(state, newVal){
      state.royaltyData = newVal;
    },
    setRoleFlags(state, newVal){
      state.roleFlags = newVal;
    }
  },
  
  plugins:[vuexAlong]
})

//设置cookie,增加到vue实例方便全局调用
//vue全局调用的理由是，有些组件所用到的接口可能需要session验证，session从cookie获取
//当然，如果session保存到vuex的话除外
Vue.prototype.setCookie = (c_name, value, expiredays) => {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
}

//获取cookie、
function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}

Vue.prototype.getCookie = getCookie;

//删除cookie
Vue.prototype.delCookie = (name) => {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

Vue.prototype.setVoiceMp3 = (status, id) => {
    // initWebSocket(){
      var websocket = null;
      //判断当前浏览器是否支持WebSocket
      if ('WebSocket' in window) {
          websocket = new WebSocket("ws://118.31.61.135:8766/webSocket//"+id);
    　　// 这里会传递一些数据，        
      }else {
          alert('当前浏览器 Not support websocket')
      }
      if(!status){
        // false 会关闭
        setTimeout(() => {
          closeWebSocket();
        });
      }else{   
        //连接发生错误的回调方法
        websocket.onerror = function () {
            setMessageInnerHTML("WebSocket连接发生错误");
        };
        //连接成功建立的回调方法
        websocket.onopen = function () {
            setMessageInnerHTML("WebSocket连接成功");
        }
        //接收到消息的回调方法
        websocket.onmessage = function (event) {
            setMessageInnerHTML(event.data);
            this.audio = new Audio();
            this.audio.src = Mp3Voice;
            this.audio.play();
        }
      }
      //连接关闭的回调方法
      websocket.onclose = function () {
          setMessageInnerHTML("WebSocket连接关闭");
      }
      //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      window.onbeforeunload = function () {
          closeWebSocket();
      }
      //将消息显示在网页上
      function setMessageInnerHTML(innerHTML) {
          console.log(innerHTML)
      }
      //关闭WebSocket连接
      function closeWebSocket() {
          websocket.close();
      }
  }


export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js